export default __webpack_public_path__ + "static/media/bannerAdvertisingPlacement.6d839fef.png";